module.exports = __webpack_public_path__ + "img/m1-screenshot-12.468a7383.png";